
export default {
  data() {
    return {
      macy: null,
      options: [
        {
          name: 'title',
          label: 'Naslov',
          type: 'text',
        },

        {
          name: 'img',
          label: 'Slika',
          type: 'image',
          size: '400x400',
        },
      ],
      optionsFood: [
        {
          name: 'food',
          label: 'Hrana',
          type: 'text',
        },
        {
          name: 'price',
          label: 'Cijena',
          type: 'text',
        },
      ],
    }
  },
  watch: {
    async $isInEditMode() {
      await this.$nextTick()
      this.macy.reInit()
    },
  },
  mounted() {
    this.macy = Macy({
      container: '#masonry-container',
      trueOrder: false,
      waitForImages: true,
      margin: 30,
      columns: 2,
      breakAt: {
        1024: 2,
        640: 1,
      },
    })
  },
}
